import Cache from '@/utils/localstore'
const TokenKey = 'USER-TOKEN'

export const getToken = () => {
  return Cache.get(TokenKey)
}

export const setToken = (token) => {
  return Cache.set(TokenKey, token)
}

export const removeToken = () => {
  Cache.rm(TokenKey)
}
